import _ from 'lodash'
import $ from 'jquery'
import Backbone from 'backbone'
import FormView from 'scoreboard/components/form-view'

const StackForm = Backbone.View.extend({

	tagName: 'form',

	/**
	 * Base view for editing the aspects of a stack of a report, the
	 * default behavior is to edit aspects of a column, but can be overriden to
	 * handle other aspects (like breakdowns, see repeat-by-form.js)
	 *
	 * @param {ReportStack} options.model the model of a Report Stack
	 * @param {ReportModel} options.reportModel the model of the report
	 * @param {ReportTableModel} options.tableModel the model of the table
	 * @param {ReportColumn} options.column the model of one of a column in a stack
	 * @param {Boolean} [options.noFetch=false] set to true if the report model
	 * should NOT fetch results in response to changes made to columns or stack
	 */
	initialize: function(options = {}) {
		this.options = options

		//keep a reference to the original report model, as some options
		//need to reference the original state
		this.options.sourceReportModel = this.options.reportModel
		let originalStack = this.model

		//make a copy of the stack and column so any changes don't affect the
		//actual model until they are finalized
		this.model = originalStack.clone()
		if (this.options.column) {
			this.column = this.model.findColumn(this.options.column)
		}

		this.reportModel = this.options.reportModel.clone()
		this.reportModel.resetStacks(this.model, {silent: true})
		this.tableModel = this.options.tableModel

		const MyFormView = FormView.extend({
			test: this.test.bind(this)
		})
		this.formView = new MyFormView({
			model: this.reportModel,
			el: this.el,
			allowCleanSubmission: true,
			submit: () => {
				$.when(this._finalize()).then(() => {
					this.trigger('done', this._onDone())
				})
			}
		})

		this.formView.on('cancel', () => this.trigger('cancel'))

		//when editing a stack, there are situations when changes should not use
		//the default behavior of fetching the results as the model changes
		this.reportModel.noFetch = !!this.options.noFetch
	},

	_onDone: function() {
		return this.column
	},

	render: function() {
		this.formView.start()
		return this
	},

	test: function() {
		return this.model.validate()
	},

	/**
	 * Post submit finailization being trigging a 'done' event.  Can return a
	 * promise to delay firing 'done' on promise
	 *
	 * @private
	 */
	_finalize: function() {
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.formView], 'remove')
	}

})

export default StackForm
StackForm.__filename__ = 'reports/common/stack-form.js'
